module.exports = "export default __webpack_public_path__ + &quot;750f99278d9bb59a0ee96bc9a5e181b6.svg&quot;;"